import { render, staticRenderFns } from "./MultiFileSelecter.vue?vue&type=template&id=4c72e7a0&scoped=true&lang=pug"
import script from "./MultiFileSelecter.vue?vue&type=script&lang=ts"
export * from "./MultiFileSelecter.vue?vue&type=script&lang=ts"
import style0 from "./MultiFileSelecter.vue?vue&type=style&index=0&id=4c72e7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72e7a0",
  null
  
)

export default component.exports